import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Table } from '../../util';
import { Loader } from '../../util/Loader';
import userAccessProjectParticipationsService from '../../services/user_access_project_participations.service';
import userAccessBusinessUnitParticipationsService from '../../services/user_access_business_unit_participations.service';
import { DeleteButton } from '../../util/buttons';
import { SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION } from '@rd-web-markets/market/dist/constants';
import claimGroupService from '../../services/claim_group.service';
export default function UnitsAndProjectsUserAccessesList(_ref) {
  let {
    userAccess,
    loading,
    setLoading,
    claimGroup,
    setClaimGroup,
    onClaimScheduleClientContactParticipationChange
  } = _ref;
  console.log('UnitsAndProjectsUserAccessesList: user Access:: ', userAccess);
  const {
    t
  } = useTranslation();
  const [localUserAccess, setLocalUserAccess] = useState(userAccess);
  useEffect(() => {
    setLocalUserAccess(userAccess);
  }, [userAccess]);
  const deleteUserAccessProjectParticipation = userAccessProjectParticipationsService.useDeleteUserAccessProjectParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const deleteUserAccessBussinessUnitParticilation = userAccessBusinessUnitParticipationsService.useDeleteUserAccessBusinessUnitParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const updateUserAccessProjectParticipation = userAccessProjectParticipationsService.useUpdate(claimGroup, setClaimGroup);
  const updateUserAccessBusinessUnitParticipation = userAccessBusinessUnitParticipationsService.useUpdate(claimGroup, setClaimGroup);
  const onDelete = async (index, row) => {
    try {
      if (row.data.participationType === 'business_unit') {
        await deleteUserAccessBussinessUnitParticilation(localUserAccess, row.data.participation, row.data.participation.business_unit_id);
      } else {
        await deleteUserAccessProjectParticipation(localUserAccess, row.data.participation, row.data.participation.claim_project_report_id);
      }
      const cg = await claimGroupService.get(claimGroup.id);
      const updatedUserAccess = cg.user_accesses.find(ua => ua.id === userAccess.id);
      setLocalUserAccess(updatedUserAccess);
      await onClaimScheduleClientContactParticipationChange();
    } finally {
      setLoading(false);
    }
  };
  const allowedActionsList = {
    project: ['technical_review', 'has_full_document_access'],
    bu: ['has_full_document_access']
  };
  const headers = [{
    text: t('permission_name')
  }, {
    text: t('type')
  },
  // SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION ? { text: t('allowed_actions') } : null,
  SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION ? {
    text: t('allow_actions')
  } : null, {
    text: t('remove_access')
  }].filter(Boolean);
  const onAddUserAccessProjectParticipationAction = useCallback(async (user_access_project_participation, action) => {
    user_access_project_participation[action] = true;
    const successMessage = `${t('successfully_added_action_permission_on_project')}`;
    return await updateUserAccessProjectParticipation({
      user_access_project_participation,
      successMessage
    });
  }, [t, updateUserAccessProjectParticipation]);
  const onRemoveUserAccessProjectParticipationAction = useCallback(async (user_access_project_participation, action) => {
    user_access_project_participation[action] = false;
    const successMessage = `${t('successfully_removed_action_permission_on_project')}`;
    return await updateUserAccessProjectParticipation({
      user_access_project_participation,
      successMessage
    });
  }, [t, updateUserAccessProjectParticipation]);
  const onAddUserAccessBusinessUnitParticipationAction = useCallback(async (user_access_business_unit_participation, action) => {
    user_access_business_unit_participation[action] = true;
    return await updateUserAccessBusinessUnitParticipation({
      user_access_business_unit_participation
    });
  }, [updateUserAccessBusinessUnitParticipation]);
  const onRemoveUserAccessBusinessUnitParticipationAction = useCallback(async (user_access_business_unit_participation, action) => {
    user_access_business_unit_participation[action] = false;
    return await updateUserAccessBusinessUnitParticipation({
      user_access_business_unit_participation
    });
  }, [updateUserAccessBusinessUnitParticipation]);
  const renderAllowedActions = _ref2 => {
    let {
      participation,
      actions,
      dropdownTestId,
      onAddAction,
      onRemoveAction
    } = _ref2;
    const availableActions = actions.filter(action => !participation[action]);
    const allowedActionDivs = actions.map(action => participation[action] ? /*#__PURE__*/React.createElement("div", {
      key: action
    }, t(action), ' ', /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: () => onRemoveAction(participation, action)
    })) : null).filter(Boolean);
    return /*#__PURE__*/React.createElement(React.Fragment, null, availableActions.length > 0 && /*#__PURE__*/React.createElement(Dropdown, {
      dataTestId: dropdownTestId,
      options: availableActions,
      onChange: action => onAddAction(participation, action)
    }), allowedActionDivs);
  };
  const renderProjectAllowedActions = projectParticipation => renderAllowedActions({
    participation: projectParticipation,
    actions: allowedActionsList.project,
    dropdownTestId: 'units_and_projects_user_accesses_list_project_action',
    onAddAction: onAddUserAccessProjectParticipationAction,
    onRemoveAction: onRemoveUserAccessProjectParticipationAction
  });
  const renderBusinessUnitAllowedActions = businessUnitParticipation => renderAllowedActions({
    participation: businessUnitParticipation,
    actions: allowedActionsList.bu,
    dropdownTestId: 'units_and_projects_user_accesses_list_business_unit_action',
    onAddAction: onAddUserAccessBusinessUnitParticipationAction,
    onRemoveAction: onRemoveUserAccessBusinessUnitParticipationAction
  });
  const rows = [...(localUserAccess.user_access_business_unit_participations || []).map((bu_particilation, idx) => {
    const rowData = {
      participationType: 'business_unit',
      participation: bu_particilation
    };
    return {
      data: rowData,
      key: bu_particilation.id,
      columns: [bu_particilation.business_unit.name, t('business_unit'), SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION ? renderBusinessUnitAllowedActions(bu_particilation) : null, SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION ? '' : null, /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-center",
        key: "delete-bu"
      }, /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => onDelete(idx, {
          data: rowData
        })
      }))].filter(Boolean)
    };
  }), ...(localUserAccess.user_access_project_participations || []).filter(p => p.claim_project_report != null).map((project_particilation, idx) => {
    const rowData = {
      participationType: 'project',
      participation: project_particilation
    };
    return {
      data: rowData,
      key: project_particilation.id,
      columns: [project_particilation.claim_project_report.project_name, t('project'), SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION ? renderProjectAllowedActions(project_particilation) : null, SHOW_ACTION_PERMISSIONS_ON_PROJECT_BUSINESS_UNIT_PARTICIPATION ? '' : null, /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-center align-items-center",
        key: "delete-project"
      }, /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => onDelete(idx, {
          data: rowData
        })
      }))].filter(Boolean)
    };
  })];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, t('current_access')), loading && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows
  }));
}